export default __webpack_public_path__ + "static/media/nav-admin-settings-fill.fe1b66b4.svg";